import React from "react";

function FacebookIcon ({className}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      fill="none"
      viewBox="0 0 28 28"
    >
      <g clipPath="url(#clip0_1065_36)">
        <path
          fill="#1877F2"
          d="M14 .7c-16.49.483-18.171 23.622-2.089 26.6h4.178C32.175 24.319 30.486 1.181 14 .7z"
        ></path>
        <path
          fill="#F1F1F1"
          d="M16.089 17.95h3.115l.593-3.869h-3.708v-2.51c0-1.058.518-2.09 2.178-2.09h1.686V6.188c-3.61-.65-7.947-.452-8.042 4.945v2.948H8.517v3.868h3.394V27.3h4.178v-9.35z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1065_36">
          <path fill="#fff" d="M0 0H28V28H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default FacebookIcon;